<div class="container mx-auto">
  <!-- Section Header -->
  <div
    class="flex flex-wrap items-center justify-between mb-4 sm:mb-6 pb-3 sm:pb-4 border-b border-base-300"
  >
    <div class="flex-1">
      <h2 class="text-xl sm:text-2xl font-bold text-base-content flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 sm:h-6 sm:w-6 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          />
        </svg>
        <span>My Classes</span>
      </h2>
      <p class="text-xs sm:text-sm text-base-content/60 mt-1">
        Manage and access all your interactive live classes
      </p>
    </div>
  </div>

  <!-- Card grid or empty state -->
  @if (myClassCards.length > 0) {
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-6">
    @for (card of myClassCards; track card.id) {
    <div class="h-full">
      <black-ui-card
        [data]="card"
        (clickMoreDetails)="onClickDetails($event)"
        (clickContinueLearning)="onClickContinue($event)"
        (clickAccessResources)="onClickAccessResources($event)"
        (clickJoinMeetings)="onClickJoinMeetings($event)"
      ></black-ui-card>
    </div>
    }
  </div>
  } @else {
  <div class="flex flex-col items-center justify-center py-16">
    @if (!isMyClassesLoading) {
    <p class="mb-6 text-lg text-gray-600">
      Your class list is currently empty.
    </p>
    }
    <button class="daisy-btn daisy-btn-primary gap-2" routerLink="/dashboard/explore-classes">
      <i class="fa-solid fa-compass"></i>
      Explore Classes
    </button>
  </div>
  }
</div>
